
import { useState, useEffect } from 'react';
import { Profile } from '@/hooks/useProfile';
import { usePersistentFormState } from '@/hooks/dashboard/usePersistentFormState';

export const useProfileFormState = (initialProfile: Profile, sectionId: string = 'profile') => {
  const [profile, setProfile, resetProfileState] = usePersistentFormState<Profile>(
    initialProfile, 
    'profile_form',
    sectionId
  );

  // If initialProfile changes (e.g., from new data fetch), update profile
  useEffect(() => {
    // Only update if profile is empty or if the new data is substantially different
    const shouldUpdate = !profile.username || 
      (initialProfile.username && profile.username !== initialProfile.username);
    
    if (shouldUpdate) {
      setProfile(initialProfile);
    }
  }, [initialProfile]);

  // Function to update a specific field in the profile
  const updateProfileField = (field: keyof Profile | string, value: any) => {
    setProfile(prev => ({ ...prev, [field]: value }));
  };

  // Function to update the entire profile
  const updateProfile = (newProfile: Partial<Profile>) => {
    setProfile(prev => ({ ...prev, ...newProfile }));
  };

  return {
    profile,
    updateProfileField,
    updateProfile,
    setProfile,
    resetProfileState
  };
};
